import { MultiLangModel } from './Language.model';

export class JobsModel {
  constructor(data = {}) {
    Object.assign(this, data);
  }

  id: string = '';
  name: MultiLangModel = new MultiLangModel();
}
